export const OUTPUT_TYPES = [
  { id: 'image',    label: 'Image',     icon: '🖼' },
  { id: 'video',    label: 'Video',     icon: '🎬' },
  { id: 'text',     label: 'Text',      icon: '📄' },
  { id: 'longform', label: 'Long Form', icon: '📝' },
  { id: 'code',     label: 'Code',      icon: '💻' },
  { id: 'prompt',   label: 'Prompt',    icon: '✦'  },
  { id: 'sop',      label: 'SOP',       icon: '📋' },
];

export const MODELS = {

  // ── Image ──────────────────────────────────────────────────
  'Image — Midjourney': [
    'Midjourney v7',
    'Midjourney v6.1',
    'Midjourney v6',
    'Midjourney Niji 7',
    'Midjourney Niji 6',
  ],
  'Image — OpenAI': [
    'GPT Image 1.5',
    'DALL-E 3',
    'DALL-E 2',
  ],
  'Image — Google': [
    'Imagen 4',
    'Imagen 3',
    'Gemini 3 Pro Image (Nano Banana Pro)',
    'Gemini 2.0 Flash (Image)',
  ],
  'Image — Flux / Black Forest Labs': [
    'FLUX.2 Pro',
    'FLUX.2 Dev',
    'FLUX.1 Kontext Pro',
    'FLUX.1 Kontext Dev',
    'FLUX1.1 Pro Ultra',
    'FLUX1.1 Pro',
    'FLUX.1 Dev',
    'FLUX.1 Schnell',
  ],
  'Image — Stability AI': [
    'Stable Diffusion 3.5 Large',
    'Stable Diffusion 3.5 Medium',
    'Stable Diffusion 3.5 Large Turbo',
    'Stable Diffusion XL',
    'Stable Image Ultra',
    'Stable Image Core',
  ],
  'Image — Adobe': [
    'Adobe Firefly Image 5',
    'Adobe Firefly Image 4',
    'Adobe Firefly Image 3',
  ],
  'Image — Other': [
    'Ideogram v2.5',
    'Ideogram v2',
    'Recraft V3',
    'Recraft 20B',
    'Leonardo Phoenix 1.5',
    'Leonardo Kino XL',
    'Seedream 4.5',
    'Z-Image-Turbo',
    'Aurora (Microsoft)',
    'Hunyuan Image',
    'Kolors (Kwai)',
    'Playground v3',
  ],

  // ── Video ──────────────────────────────────────────────────
  'Video — OpenAI': [
    'Sora 2 Pro',
    'Sora 2',
    'Sora (v1)',
  ],
  'Video — Google': [
    'Veo 3.1',
    'Veo 3',
    'Veo 2',
  ],
  'Video — Runway': [
    'Runway Gen-4 Turbo',
    'Runway Gen-4',
    'Runway Gen-3 Alpha',
    'Runway Gen-3 Alpha Turbo',
  ],
  'Video — Kling (Kuaishou)': [
    'Kling 3.0',
    'Kling 2.6 Pro',
    'Kling 2.1 Master',
    'Kling 2.1',
    'Kling 2.0',
    'Kling 1.6 Pro',
    'Kling 1.6',
  ],
  'Video — Luma': [
    'Luma Ray3',
    'Luma Ray 2 Flash',
    'Luma Ray 2',
    'Luma Dream Machine',
  ],
  'Video — Pika': [
    'Pika 2.5',
    'Pika 2.2',
    'Pika 2.1 Turbo',
    'Pika 2.0',
  ],
  'Video — Hailuo (MiniMax)': [
    'Hailuo 02 Pro',
    'Hailuo 02',
    'Hailuo T2V-01 Director',
    'Hailuo T2V-01',
  ],
  'Video — Other': [
    'Seedance 1.5 Pro',
    'Seedance 1.0',
    'Wan 2.6',
    'Wan 2.2',
    'Wan 2.1',
    'LTX 2.0',
    'LTX Video',
    'Hunyuan Video',
    'Adobe Firefly Video',
    'Genmo Mochi 1',
    'Nova Reel (Amazon)',
    'Stable Video Diffusion',
    'CogVideoX',
  ],

  // ── Text / LLM ─────────────────────────────────────────────
  'Text — Anthropic (Claude)': [
    'Claude 4.6 Opus',
    'Claude 4.6 Sonnet',
    'Claude 4.5 Opus',
    'Claude 4.5 Sonnet',
    'Claude 4 Opus',
    'Claude 4 Sonnet',
    'Claude 3.7 Sonnet',
    'Claude 3.5 Sonnet',
    'Claude 3.5 Haiku',
    'Claude 3 Opus',
  ],
  'Text — OpenAI (GPT)': [
    'GPT-5.4',
    'GPT-5.2',
    'GPT-5.1',
    'GPT-5',
    'GPT-4.5',
    'GPT-4o',
    'GPT-4o mini',
    'o3 Pro',
    'o3',
    'o3 mini',
    'o1 Pro',
    'o1',
    'o1 mini',
  ],
  'Text — Google (Gemini)': [
    'Gemini 3.1 Pro',
    'Gemini 3.1 Flash',
    'Gemini 3.1 Flash Lite',
    'Gemini 3 Pro (Deep Think)',
    'Gemini 3 Flash',
    'Gemini 2.5 Pro',
    'Gemini 2.5 Flash',
    'Gemini 2.0 Flash',
    'Gemini 2.0 Flash Thinking',
    'Gemini 1.5 Pro',
  ],
  'Text — Meta (Llama)': [
    'Llama 4 Maverick',
    'Llama 4 Scout',
    'Llama 3.3 70B',
    'Llama 3.1 405B',
    'Llama 3.1 70B',
    'Llama 3.1 8B',
  ],
  'Text — Mistral': [
    'Mistral Large 3',
    'Mistral Large 2',
    'Mistral Medium 3',
    'Mistral Small 3.1',
    'Magistral Medium',
    'Magistral Small',
    'Ministral 3B',
    'Ministral 8B',
    'Mixtral 8x22B',
    'Pixtral Large',
    'Pixtral 12B',
  ],
  'Text — DeepSeek': [
    'DeepSeek V3.2',
    'DeepSeek V3',
    'DeepSeek R1',
    'DeepSeek R1 Zero',
    'DeepSeek-R2',
  ],
  'Text — xAI (Grok)': [
    'Grok 4.1 Thinking',
    'Grok 4.1',
    'Grok 4',
    'Grok 3 Thinking',
    'Grok 3',
    'Grok 3 Mini',
    'Grok 2',
  ],
  'Text — Alibaba (Qwen)': [
    'Qwen3.5 Max',
    'Qwen3 235B-A22B',
    'Qwen3 72B',
    'Qwen3 32B',
    'Qwen3 14B',
    'Qwen3 8B',
    'Qwen2.5 72B',
    'QwQ-32B',
  ],
  'Text — Perplexity': [
    'Sonar Pro',
    'Sonar Reasoning Pro',
    'Sonar',
    'Sonar Reasoning',
  ],
  'Text — Other': [
    'Command R+ (Cohere)',
    'Command R (Cohere)',
    'Kimi 1.5 (Moonshot)',
    'Kimi k1.5',
    'Nemotron-4 340B (Nvidia)',
    'Granite 3.3 (IBM)',
    'Phi-4 (Microsoft)',
    'Phi-3.5 (Microsoft)',
    'Yi-Large (01.AI)',
    'Falcon 180B (TII)',
    'MPT-30B (MosaicML)',
  ],

  // ── Code ───────────────────────────────────────────────────
  'Code — AI Editors / IDEs': [
    'Cursor (Claude 4.6 Sonnet)',
    'Cursor (GPT-4o)',
    'Cursor (o3)',
    'GitHub Copilot (GPT-4o)',
    'GitHub Copilot (Claude Sonnet)',
    'Windsurf (Claude)',
    'Windsurf (GPT-4o)',
    'Zed AI',
    'JetBrains AI Assistant',
    'Amazon CodeWhisperer',
    'Replit AI',
    'Bolt.new',
    'v0 (Vercel)',
    'Lovable',
  ],
  'Code — Models': [
    'Claude 4.6 Sonnet (Code)',
    'GPT-4o (Code)',
    'o3 (Code)',
    'Gemini 3 Flash (Code)',
    'DeepSeek V3.2 (Code)',
    'DeepSeek Coder V2',
    'Codestral (Mistral)',
    'Devstral Small 1.1 (Mistral)',
    'Qwen2.5-Coder 32B',
    'Llama 4 Scout (Code)',
    'StarCoder2 15B',
    'Code Llama 70B',
    'WizardCoder',
  ],

  // ── Long Form ─────────────────────────────────────────────────
  'Long Form — Anthropic': [
    'Claude 4.6 Opus (Long Form)',
    'Claude 4.6 Sonnet (Long Form)',
    'Claude 4 Opus (Long Form)',
    'Claude 3.7 Sonnet (Long Form)',
  ],
  'Long Form — OpenAI': [
    'GPT-5.4 (Long Form)',
    'GPT-5 (Long Form)',
    'GPT-4o (Long Form)',
    'o3 Pro (Long Form)',
    'o3 (Long Form)',
  ],
  'Long Form — Google': [
    'Gemini 3 Pro (Long Form)',
    'Gemini 2.5 Pro (Long Form)',
    'Gemini 2.0 Flash (Long Form)',
  ],
  'Long Form — Other': [
    'DeepSeek V3.2 (Long Form)',
    'Grok 4.1 (Long Form)',
    'Llama 4 Maverick (Long Form)',
    'Mistral Large 3 (Long Form)',
    'Qwen3.5 Max (Long Form)',
    'Sudowrite',
    'Jasper',
    'Copy.ai',
    'Rytr',
    'Writesonic',
  ],

  // ── Audio / Voice (bonus) ──────────────────────────────────
  'Audio — TTS / Voice': [
    'ElevenLabs v3',
    'ElevenLabs Turbo v2.5',
    'OpenAI TTS-1 HD',
    'OpenAI TTS-1',
    'Google Text-to-Speech (WaveNet)',
    'Chatterbox (Resemble AI)',
    'Kokoro TTS',
    'Bark (Suno)',
    'PlayHT 3.0',
    'LMNT',
  ],
  'Audio — Music': [
    'Suno v4.5',
    'Suno v4',
    'Udio v1.5',
    'Udio v1',
    'MusicGen (Meta)',
    'AudioCraft (Meta)',
    'Stable Audio 2.0',
  ],
};

export const TYPE_ICONS = {
  image:    '🖼',
  video:    '🎬',
  text:     '📄',
  longform: '📝',
  code:     '💻',
  prompt:   '✦',
  sop:      '📋',
};

// Flat sorted list of all unique model names for the filter dropdown
export const ALL_MODELS = [...new Set(
  Object.values(MODELS).flat()
)].sort((a, b) => a.localeCompare(b));

// Model groups for the grouped dropdown in EntryForm
export const MODEL_GROUPS = MODELS;

export function formatDate(iso) {
  const d = new Date(iso);
  const now = new Date();
  const diff = now - d;
  if (diff < 60000) return 'Just now';
  if (diff < 3600000) return `${Math.floor(diff / 60000)}m ago`;
  if (diff < 86400000) return 'Today';
  if (diff < 172800000) return 'Yesterday';
  return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
}
